"use client"

import {getSession} from "next-auth/react";
import fileDownload from "js-file-download";
import {useState} from "react";
import {api} from "@/lib/api/api";
import axiosInstance from "@/lib/api/axios";
import {useResponseValidate} from "@/lib/hook/useResponseValidate";

export const useApiFileDownload = () => {
    const [isFetching, setIsFetching] = useState(false)
    const {successValidate, errorValidate} = useResponseValidate()
    const fetch = async ({route: {name, query}, data, setting = {}}) => {
        const {
            headers = {},
            fileName,
        } = setting

        setIsFetching(true)

        const {url, method} = api.getRoute(name, query)

        const session = await getSession()

        axiosInstance.request({
            responseType: 'blob',
            url,
            method,
            headers: {
                Authorization: `Bearer ${session.accessToken}`,
                ...headers,
            },
            [['GET', 'DELETE'].includes(method) ? "params" : "data"]: data
        }).then(res => {
            successValidate(res)
            fileDownload(res.data, fileName ?? 'fileName');
        })
            .catch((error) => {
                errorValidate(error, '')
            })
            .finally(() => {
                setIsFetching(false)
            });
    }

    return {
        fetch,
        isFetching,
    }
};
